<span>{{ type | experienceBrandFormat }}</span>
<sup>TM</sup>

